const defaultConfig = {
  PENDING: '+pending',
  SUCCESS: '+success',
  REJECTED: '+rejected',
  params: () => undefined,
};

export default config => (store) => {
  config = { ...defaultConfig, ...config };

  store.$bind = function ({ commit }, actionType, meta) {
    function commitSafe(action, body) {
      try {
        commit(action, body);
      } catch (e) {
        console.log(e);
      }
    }

    return {
      async with(promise) {
        commitSafe(`${actionType}${config.PENDING}`, { meta });

        try {
          const result = await (typeof promise === 'function' ? promise(config.params()) : promise);
          commitSafe(`${actionType}${config.SUCCESS}`, { payload: result, meta });
          return result;
        } catch (e) {
          commitSafe(`${actionType}${config.REJECTED}`, { payload: e, meta });

          return Promise.reject(e);
        }
      },
    };
  };
};
